import React from 'react';
import { MenuSection as AriaMenuSection } from 'react-aria-components';

import styles from './Menu.module.scss';

type Props = {
  children: React.ReactNode;
};
export const MenuSection = ({ children }: Props) => {
  return (
    <AriaMenuSection className={styles.MenuSection}>{children}</AriaMenuSection>
  );
};
